export default "__VITE_ASSET__8rxHTh_K__"